
  import ScreenSize from '@/mixins/ScreenSize';
  export default {
    components: {
      RichText: () => import('@/components/elements/RichText'),
    },
    mixins: [ScreenSize],
    props: {
      element: {
        type: Object,
        required: true,
        default: () => {},
      },
    },
  };
